import { useQuery } from "@apollo/client";
import React from "react";
import { QUERY_GET_CMS_BLOCKS } from "~/data/home";

type Props = {
  indentifiers: string[];
};

const BlockContent = ({ indentifiers = [] }: Props) => {
  const { data, loading } = useQuery(QUERY_GET_CMS_BLOCKS, {
    variables: {
      identifiers: indentifiers,
    },
  });
  if (loading) return null;
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: data?.cmsBlocks?.items?.[0]?.content || "",
      }}
    ></div>
  );
};

export default BlockContent;
